import { cn } from '@plura/shared/utils';
import Image from 'next/image';

export interface FancyBucketsCalloutProps {
  title: string;
  description: string;
  image: string;
  items: {
    title: string;
    description: string;
  }[];
}

const FancyBucketsCallout = ({ title, description, image, items }: FancyBucketsCalloutProps) => {
  return (
    <div className="w-full bg-b-surface1">
      <div
        className={cn(
          'mx-auto flex w-full max-w-[1280px] flex-col items-center justify-center gap-20 px-5 py-20 lg:px-20',
          'max-lg:py-[60px]',
        )}
      >
        <div className="flex w-full flex-row items-center justify-between gap-10 max-lg:flex-col max-lg:items-start max-lg:gap-[30px]">
          <div className="w-1/2 max-w-[500px] max-lg:w-full">
            <h3 className="mb-2.5 text-h3 text-t-primary">{title}</h3>
            <p className="text-base font-medium leading-[1.7] text-t-secondary">{description}</p>
          </div>
          <div
            className={cn(
              'flex w-1/2 items-center justify-center max-lg:w-full',
              'gridBackground',
            )}
          >
            <Image
              src={image}
              alt={title}
              width={480}
              height={400}
              sizes="(max-width: 768px) 100vw, 50vw"
              className="relative z-[3] h-auto w-full max-w-[480px] object-contain object-center"
            />
          </div>
        </div>
        <div className="flex w-full flex-row items-center justify-between gap-10 max-lg:flex-col max-lg:gap-[30px]">
          {items.map((item, index) => (
            <div key={index} className="flex flex-col items-start gap-2.5">
              <h4 className="text-h5 text-t-primary">{item.title}</h4>
              <p
                className="text-base font-medium leading-[1.7] text-t-secondary"
                dangerouslySetInnerHTML={{ __html: item.description }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FancyBucketsCallout;
